enum FormFields {
  Name = "name",
  Place = "place",
  Radius = "radius",
  MinPropertyPrice = "min",
  MaxPropertyPrice = "max",
  BuildingTypes = "buildingTypes",
  NumberOfBedrooms = "numberOfBedrooms",
  NumberOfBathrooms = "numberOfBathrooms",
  FeaturesAndAmenities = "featuresAndAmenities",
  ConstructionDate = "constructionDate",
  NumberOfUnits = "numberOfUnits",
  ProjectStatus = "projectStatus",
  YearBuilt = "yearBuilt",
  Markets = "markets",
  TransactionType = "transactionType",
}

const FormFieldsList = [
  FormFields.Name,
  FormFields.Place,
  FormFields.Radius,
  FormFields.MinPropertyPrice,
  FormFields.MaxPropertyPrice,
  FormFields.BuildingTypes,
  FormFields.NumberOfBathrooms,
  FormFields.NumberOfBedrooms,
  FormFields.FeaturesAndAmenities,
  FormFields.ConstructionDate,
  FormFields.NumberOfUnits,
  FormFields.ProjectStatus,
  FormFields.YearBuilt,
  FormFields.Markets,
  FormFields.TransactionType,
];

export { FormFields, FormFieldsList };
